import { InjectionToken, Provider } from '@angular/core';

export interface AuthSplitLayoutConfig {
  appName?: string;
  logoUrl?: string;
  logoAlt?: string;
  logoLink?: string;
  heroTitle?: string;
  heroSubtitle?: string;
  heroDescription?: string;
  heroSocialProof?: string;
}

export const AUTH_SPLIT_LAYOUT_CONFIG = new InjectionToken<AuthSplitLayoutConfig>('AUTH_SPLIT_LAYOUT_CONFIG');

export function provideAuthSplitLayoutConfig(config: AuthSplitLayoutConfig): Provider {
  return {
    provide: AUTH_SPLIT_LAYOUT_CONFIG,
    useValue: config,
  };
}
